import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { IonicModule } from '@ionic/angular'

import { CreateBuildingPageRoutingModule } from './create-building-routing.module'

import { CreateBuildingPage } from './create-building.page'
import { MatIconModule } from '@angular/material/icon'
import { ComponentsModule } from 'src/app/components/components.module'
import { MatInputModule } from '@angular/material/input'
import { ListboxModule } from 'primeng/listbox'
import { TextareaModule } from 'primeng/textarea'
import { MatChipsModule } from '@angular/material/chips'
import { InputTextModule } from 'primeng/inputtext'
import { FloatLabelModule } from 'primeng/floatlabel'
import { MainPipeModule } from 'src/app/pipes/main-pipe.module'
import { ButtonModule } from 'primeng/button'
import { DropdownModule } from 'primeng/dropdown'
import { InputGroupModule } from 'primeng/inputgroup'
import { InputGroupAddonModule } from 'primeng/inputgroupaddon'

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    IonicModule,
    ListboxModule,
    TextareaModule,
    MatInputModule,
    MatChipsModule,
    MatIconModule,
    InputTextModule,
    FloatLabelModule,
    MainPipeModule,
    ButtonModule,
    DropdownModule,
    InputGroupModule,
    InputGroupAddonModule,
    CreateBuildingPageRoutingModule,
  ],
  providers: [
    {
      provide: 'MAT_CHIPS_DEFAULT_OPTIONS',
      useValue: {
        separatorKeyCodes: [13, 188],
      },
    },
  ],
  declarations: [CreateBuildingPage],
})
export class CreateBuildingPageModule {}
